import { SeatPreferenceSelectionInput } from '@eti/schema-types';
const checkRowCharacteristics = (row, characteristic) => {
  var _row$characteristics;
  return (_row$characteristics = row.characteristics) === null || _row$characteristics === void 0 ? void 0 : _row$characteristics.some(rowCharacteristic => rowCharacteristic === characteristic);
};
export const isExitRow = row => checkRowCharacteristics(row, 'EXIT_ROW');
export const isEmptyRow = row => checkRowCharacteristics(row, 'EMPTY_ROW');
export const isRowOverWing = row => checkRowCharacteristics(row, 'OVER_WING_ROW');
const isBetweenAisles = (prev, curr) => prev.type === SeatPreferenceSelectionInput.Aisle && curr.type === SeatPreferenceSelectionInput.Aisle;
const emptyDetailsAisle = {
  columnName: null,
  type: 'EMPTY'
};
export const addAislesToColumnDetails = details => details.reduce((prev, detail, index) => {
  if (index > 0 && isBetweenAisles(details[index - 1], detail)) {
    prev.push(emptyDetailsAisle);
  }
  prev.push(detail);
  return prev;
}, []);
const addEmptySeatForMissingSeatInRow = (rowNumber, columnName) => ({
  column: columnName,
  isBookable: false,
  mainCharacteristic: null,
  row: rowNumber,
  seat: String(rowNumber !== null && rowNumber !== void 0 ? rowNumber : '') + columnName,
  type: 'EMPTY',
  characteristics: []
});
const newAisle = _ref => {
  let {
    rowNumber
  } = _ref;
  return {
    column: null,
    row: rowNumber,
    type: SeatPreferenceSelectionInput.Aisle,
    characteristics: []
  };
};
const newRowItem = (row, column) => {
  const seatByColumnName = row.sellSeatMapSeats.find(seat => seat.column === column.columnName);
  return seatByColumnName || addEmptySeatForMissingSeatInRow(row.rowNumber, column.columnName);
};
export const addAislesToRows = (cabinRows, columnDetails) => {
  return cabinRows.map(row => {
    const newRowSeats = columnDetails.reduce((prev, column) => {
      var _row$sellSeatMapSeats;
      const safeRow = {
        sellSeatMapSeats: (_row$sellSeatMapSeats = row.sellSeatMapSeats) !== null && _row$sellSeatMapSeats !== void 0 ? _row$sellSeatMapSeats : [],
        rowNumber: row.rowNumber
      };
      if (column.type === 'EMPTY') {
        prev.push(newAisle(safeRow));
      } else {
        prev.push(newRowItem(safeRow, {
          columnName: column.columnName
        }));
      }
      return prev;
    }, []);
    return {
      ...row,
      sellSeatMapSeats: newRowSeats
    };
  });
};
const addExplicitEmptyRow = row => {
  const emptyRowLayout = (row.sellSeatMapSeats || []).map((seat, index, arr) => {
    if (index === 0 || index === arr.length - 1) {
      return {
        column: seat === null || seat === void 0 ? void 0 : seat.column,
        type: 'EXIT_ARROW'
      };
    }
    return {
      column: seat === null || seat === void 0 ? void 0 : seat.column
    };
  });
  return {
    characteristics: ['EMPTY_ROW', ...(isRowOverWing(row) ? ['OVER_WING_ROW'] : [])],
    rowNumber: null,
    sellSeatMapSeats: emptyRowLayout
  };
};
export const addExitRows = cabinRows => cabinRows ? cabinRows.reduce((prev, row) => checkRowCharacteristics(row, 'EXIT_ROW') ? [...prev, addExplicitEmptyRow(row), row] : [...prev, row], []) : null;
//# sourceMappingURL=layout.js.map